import { render, staticRenderFns } from "./StatisticsCard.vue?vue&type=template&id=7fd1a6da&"
import script from "./StatisticsCard.vue?vue&type=script&lang=js&"
export * from "./StatisticsCard.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports